import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell, ModalRef } from "@shared/components";
import { useMediaTypeOptions, useSectorOptions } from "@shared/options";

export const useBookActivitieListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  editBookActivityModalRef: RefObject<ModalRef>
): GridColDef[] => {
  const { getMediaTypeOptions } = useMediaTypeOptions();
  const { getSectorOptions } = useSectorOptions();

  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "name",
        headerName: translate("book_activity_admin.fields.name"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "sector",
        headerName: translate("book_activity_admin.fields.sector"),
        minWidth: 120,
        headerAlign: "center",
        type: "singleSelect",
        valueOptions: getSectorOptions(),
        renderCell: ({ value }) => {
          const option = getSectorOptions().find(opt => String(opt.value) === String(value));
          return (
            <TableCell.Text
              value={option?.label}
              align="center"
            />
          );
        },
      },
      {
        field: "type",
        headerName: translate("book_activity_admin.fields.type"),
        minWidth: 120,
        headerAlign: "center",
        type: "singleSelect",
        valueOptions: getMediaTypeOptions(),
        renderCell: ({ value }) => {
          const option = getMediaTypeOptions().find(opt => opt.value === value);
          return (
            <TableCell.Text
              value={option?.label}
              align="center"
            />
          );
        },
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => editBookActivityModalRef.current?.open(row)}
            />
            <DeleteButton
              hideText
              recordItemId={row.id}
              resource="v1/book_activity_admin"
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, editBookActivityModalRef, getMediaTypeOptions, getSectorOptions]
  );
};
